import { Route, Routes } from 'react-router-dom';

import { lazyImport } from 'utils/lazyImport';

const { LoginPage } = lazyImport(() => import('../pages/LoginPage'), 'LoginPage');
const { TwoFactorAuthenticationPage } = lazyImport(
  () => import('../pages/TwoFactorAuthenticationPage'),
  'TwoFactorAuthenticationPage'
);
const { OtpPage } = lazyImport(() => import('../pages/OtpPage'), 'OtpPage');
const { RecoveryCodePage } = lazyImport(
  () => import('../pages/RecoveryCodePage'),
  'RecoveryCodePage'
);
const { ForgotPasswordPage } = lazyImport(
  () => import('../pages/ForgotPasswordPage'),
  'ForgotPasswordPage'
);
const { PasswordResetOtpPage } = lazyImport(
  () => import('../pages/PasswordResetOtpPage'),
  'PasswordResetOtpPage'
);
const { ResetPasswordPage } = lazyImport(
  () => import('../pages/ResetPasswordPage'),
  'ResetPasswordPage'
);
const { OtpValidationPage } = lazyImport(
  () => import('../pages/OtpValidationPage'),
  'OtpValidationPage'
);

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="two-factor-authentication" element={<TwoFactorAuthenticationPage />} />
      <Route path="sign-in/otp" element={<OtpPage />} />
      <Route path="sign-in/recovery-code" element={<RecoveryCodePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/password-reset-otp" element={<PasswordResetOtpPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/otp-validation" element={<OtpValidationPage />} />
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
};
